import City, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/city';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;

export default City;
